import { AccountService } from '~modules/features/account';
export default [
    {
        name: 'view',
        path: '/',
        component: () => import('./Account').then(m => m.default),
        onActivate: AccountService.getOne
    }
];
